import { render, staticRenderFns } from "./DepositChannelDropdown.vue?vue&type=template&id=565acba9"
import script from "./DepositChannelDropdown.vue?vue&type=script&lang=js"
export * from "./DepositChannelDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports